import Vue from 'vue'
import store from '@/store'
import ChooseColumnsPopupComponent from './ChooseColumns.vue'

const ChooseColumns = {
  install(Vue, options) {
    Vue.prototype.$ChooseColumns430 = (function(options) {
      let vm
      return function(options) {
        if (!vm) {
          const ChooseColumnsConstructor = Vue.extend(
            ChooseColumnsPopupComponent
          )
          const div = document.createElement('div')
          document.body.appendChild(div)
          vm = new ChooseColumnsConstructor({
            store: this.$store,
            propsData: options
          }).$mount(div)

          vm.handleShow(options)
          return vm
        } else {
          vm.handleShow(options)
        }
      }
    })()
  }
}

export default ChooseColumns
